import "./App.css";
import {ToastContainer} from "react-toastify";
import Router from "./router/router";
import React, {useEffect} from "react";
import {auth, generateToken, messaging} from './firebase';
import {onMessage} from "firebase/messaging";
import {addNotification} from "./redux/notificationSlice";
import {useDispatch} from "react-redux";
import { onAuthStateChanged } from "@firebase/auth";
import FeatureIdDebugger from "./components/FeatureDebugger";


function App() {
    const dispatch = useDispatch();

        // Register service worker on app mount
    useEffect(() => {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker
                .register("/firebase-messaging-sw.js")
                .then((registration) => {
                })
                .catch((error) => {
                    console.error("❌ Service Worker registration failed:", error);
                });
        } else {
            console.warn("⚠️ Service Workers are not supported in this browser");
        }
    }, []);

    // please dont delete
    const refreshToken = async (user: any) => {
        try {
          const token = await user.getIdToken(true);
          localStorage.setItem("accessToken", token);
        } catch (error) {
          console.error("Token refresh failed:", error);
        }
      };
    
      useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
          if (user) {
            refreshToken(user);
          } else {
            
          }
        });
    
        return () => unsubscribe();
      }, []);
    
    const handleNotification = (
    payload: any,
    source: "foreground" | "background",
  ) => {
    if (source === "foreground") {
      const notification = {
        id: payload.messageId || Date.now(),
        title: payload.notification?.title || "Notification",
        body: payload.notification?.body || "",
        orderId: payload.data?.orderId || "",
        orderStatus: payload.data?.orderStatus || "",
        timestamp: Date.now(),
      };
      dispatch(addNotification(notification));
    }
    if (source === "background") {
      const notification = {
        id: payload.id || Date.now(),
        title: payload.title || "Notification",
        body: payload.body || "",
        orderId: payload.orderId || "",
        orderStatus: payload.orderStatus || "",
        timestamp: Date.now(),
      };
      dispatch(addNotification(notification));
    }
  };

  // Foreground messages
  useEffect(() => {
    generateToken(); // Request FCM token
    const unsubscribe = onMessage(messaging, (payload) => {
      handleNotification(payload, "foreground");
    });

    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // Background messages via service worker
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const messageHandler = (event: MessageEvent) => {
      if (event.data?.type === "NEW_BACKGROUND_NOTIFICATION") {
        handleNotification(event.data.payload, "background");
      }
    };

    navigator.serviceWorker.addEventListener("message", messageHandler);

    navigator.serviceWorker.ready.then((registration) => {
      registration.active?.postMessage({ type: "INIT_CLIENT" });
    });

    return () => {
      navigator.serviceWorker.removeEventListener("message", messageHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

    return (
        <>
            <Router/>
            <ToastContainer/>
             <FeatureIdDebugger />
        </>
    );
}

export default App;
